<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<!-- {{"ADD" | translate }} {{"GRUPO" | translate }} -->
<form [formGroup]="itemForm" (ngSubmit)="submit()"></form>
<div mat-dialog-content>
  <mat-card class="p-0">
    <mat-tab-group>
      <mat-tab label="Grupo">
        <form [formGroup]="itemForm" (ngSubmit)="submit()">
          <div fxLayout="row wrap" fxLayout.lt-sm="column">
            <div fxFlex="100" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskUpper" matInput type="text" name="classificacao"
                  [formControl]="itemForm.controls['classificacao']" placeholder="Classificação">
              </mat-form-field>
              <small
                *ngIf="itemForm.controls['classificacao'].hasError('required') && itemForm.controls['classificacao'].touched"
                class="form-error-msg"> Classificação é obrigatório </small>
            </div>
            <div fxFlex="100" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskUpper" name="descricao" matInput type="text"
                  [formControl]="itemForm.controls['descricao']" placeholder="Descrição">
              </mat-form-field>
              <small
                *ngIf="itemForm.controls['descricao'].hasError('required') && itemForm.controls['descricao'].touched"
                class="form-error-msg"> Descrição é obrigatório </small>
            </div>

            <div fxFlex="100" class="mt-1">
              <button mat-raised-button color="primary" [disabled]="itemForm.invalid">{{"SAVE" | translate }}</button>
              <span fxFlex></span>
              <button mat-button color="warn" type="button" (click)="close()">{{"CLOSE" | translate }}</button>
            </div>
          </div>
        </form>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</div>